// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "282bca7e0dd33fb2244820256037cfa1" + ".css";
};